
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Text } from "rebass/styled-components";
import { getApolloClient, addApolloState } from "@faustwp/core";
import { GetServerSidePropsContext } from "next";
import PostPage from "../../components/PostPage";
import Layout from "../../components/Layout";
import useIsMobile from "../../hooks/useIsMobile";
import { InferredPost } from "../../types";
import theme from "../../styles/theme";
import { useGetBreedsPageDataQuery, GetBreedsPageDataDocument, } from "../../generated/graphql";
export default function CategoryMainPage(props: any) {
    const isMobile = useIsMobile();
    const { data } = useGetBreedsPageDataQuery();
    const breeds = data?.breeds?.nodes || [];
    const totalPosts: NonNullable<number> = data?.breeds?.pageInfo.offsetPagination?.total || 0;
    return (<Layout>
      <>
        <Text as="h1" sx={theme.mainTitle}>
          Breeds
        </Text>
        <PostPage basePath={""} posts={breeds} isMobile={isMobile} pageSelected={1} totalPosts={totalPosts} slim/>
      </>
    </Layout>);
}
const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const apolloClient = getApolloClient();
    const result = await Promise.all([
        apolloClient.query({
            query: GetBreedsPageDataDocument,
        }),
    ]);
    if (!result[0].data?.breeds?.nodes[0]) {
        return {
            notFound: true,
        };
    }
    return addApolloState(apolloClient, {
        props: {},
    });
};

    async function __Next_Translate__getServerSideProps__1985569e6c5__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/breeds/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1985569e6c5__ as getServerSideProps }
  